import UserModel from 'Models/UserModel';

export default function admin(store) {
  function getUserInfo() {
    let { user } = store.state;
    if (window && window.user) {
      user = window.user;
    }

    return user;
  }

  const checkCurrencyMarketPlaceAccess = (to, from, next) => {
    const userId = getUserInfo()?.id;
    let canAccess = process.env.CURRENCY_MARKETPLACE_CAN_ENTER_ADMIN_SECTION ?? '';
    canAccess = canAccess === '' ? [] : canAccess.split(',');

    if (canAccess.length === 0 || canAccess.includes(String(userId))) {
      next();
      return;
    }

    next('/admin');
  };

  return [
    {
      name: 'admin',
      path: '/admin',
      meta: {
        title: 'Admin panel',
        roles: UserModel.ROLES.MANAGERS_ROLES_LIST.map((role) => role.id),
        authorizedOnly: true,
      },
      redirect() {
        const customRedirectsByRoles = {
          [UserModel.ROLES.CONTENT_MANAGER.id]: { name: 'admin-products' },
          [UserModel.ROLES.FINANCE_MANAGER.id]: { name: 'finance-reports' },
          [UserModel.ROLES.SALES_HEAD.id]: { name: 'admin-upsales' },
        };

        const userRole = getUserInfo()?.role;
        return customRedirectsByRoles[userRole] ?? { name: 'admin-orders__all' };
      },
      component: () => import('Root/pages/admin/Admin.vue'),

      children: [
        {
          path: 'dashboard',
          name: 'admin-dashboard',
          meta: {
            title: 'Dashboard',
            showInMenu: true,
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: [],
          },
          component: () => import('Root/pages/admin/Dashboard.vue'),
        },
        {
          path: 'analytics',
          name: 'admin-analytics',
          meta: {
            showInMenu: true,
            title: 'Analytics',
            icon: 'analytics.svg',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.FINANCE_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/analytics/Analytics.vue'),
          redirect: { name: 'admin-analytics__general' },
          children: [
            {
              path: 'general',
              name: 'admin-analytics__general',
              component: () => import('Root/pages/admin/analytics/tabs/AnalyticsGeneral.vue'),
            },
            {
              path: 'booster-finance',
              name: 'admin-analytics__booster-finance',
              component: () => import('Root/pages/admin/analytics/tabs/AnalyticsBoosterFinance.vue'),
            },
          ],
        },
        {
          path: 'top-sales',
          name: 'admin-top-sales',
          meta: {
            showInMenu: true,
            icon: 'analytics.svg',
            title: 'Top sales',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/TopSales.vue'),
        },

        {
          path: 'kpi-plans',
          name: 'admin-kpi-plans',
          meta: {
            showInMenu: true,
            title: 'Sale plans',
            roles: [UserModel.ROLES.ADMIN.id],
            icon: 'analytics.svg',
          },
          component: () => import('Root/pages/admin/kpi-plans/KpiPlans.vue'),
          redirect: { name: 'admin-kpi-plans__sales' },
          children: [
            {
              path: 'sales',
              name: 'admin-kpi-plans__sales',
              component: () => import('Root/pages/admin/kpi-plans/tabs/KpiPlansSales.vue'),
            },
          ],
        },

        {
          path: 'orders',
          name: 'admin-orders',
          meta: {
            showInMenu: true,
            icon: 'orders.svg',
            title: 'Orders',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.PROJECT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/orders/Orders.vue'),
          redirect: { name: 'admin-orders__all' },
          children: [
            {
              path: 'all',
              name: 'admin-orders__all',
              component: () => import('Root/pages/admin/orders/tabs/ManagerCabinet.vue'),
            },
            {
              path: 'normal',
              name: 'admin-orders__normal',
              component: () => import('Root/pages/admin/orders/tabs/Orders.vue'),
            },
            {
              path: 'custom',
              name: 'admin-orders__custom',
              component: () => import('Root/pages/admin/orders/tabs/CustomOrders.vue'),
            },
            {
              path: 'finished',
              name: 'admin-orders__finished',
              component: () => import('Root/pages/admin/orders/tabs/FinishedOrders.vue'),
            },
            {
              path: 'currency',
              name: 'admin-orders__currency',
              component: () => import('Root/pages/admin/orders/tabs/ManagerCabinet.vue'),
            },
            {
              path: 'tips',
              name: 'admin-orders__tips',
              component: () => import('Root/pages/admin/orders/tabs/TipsOrders.vue'),
            },
            {
              path: 'dubious',
              name: 'admin-orders__dubious',
              component: () => import('Root/pages/admin/orders/tabs/DubiousOrders.vue'),
            },
            {
              path: 'abandoned',
              name: 'admin-orders__abandoned',
              component: () => import('Root/pages/admin/orders/tabs/AbandonedOrders.vue'),
            },
            {
              path: 'refunds',
              name: 'admin-orders__refunds',
              component: () => import('Root/pages/admin/orders/tabs/RefundsOrders.vue'),
            },
            {
              path: 'disputes',
              name: 'admin-orders__disputes',
              component: () => import('Root/pages/admin/orders/tabs/DisputesOrders.vue'),
            },
            {
              path: 'bad-executed',
              name: 'admin-orders__bad-executed',
              component: () => import('Root/pages/admin/orders/tabs/BadExecuted.vue'),
            },
            {
              path: 'forbidden-words',
              name: 'admin-orders__forbidden-words',
              component: () => import('Root/pages/admin/orders/tabs/ForbiddenWordsOrders.vue'),
            },
            {
              path: 'low-profit',
              name: 'admin-orders__low-profit',
              component: () => import('Root/pages/admin/orders/tabs/LowProfitOrders.vue'),
            },
            {
              path: 'pro-upsales',
              name: 'admin-orders__pro-upsales',
              component: () => import('Root/pages/admin/orders/tabs/ProUpsaleOrders.vue'),
            },
            {
              path: 'manual-price-changed',
              name: 'admin-orders__manual-price-changed',
              component: () => import('Root/pages/admin/orders/tabs/ManualPriceChangedOrders.vue'),
            },
            {
              path: 'long-in-progress',
              name: 'admin-orders__long-in-progress',
              component: () => import('Root/pages/admin/orders/tabs/LongInProgress.vue'),
            },
            {
              path: 'reassigned',
              name: 'admin-orders__reassigned',
              component: () => import('Root/pages/admin/orders/tabs/ReassignedOrders.vue'),
            },
          ],
        },

        {
          path: 'games',
          name: 'admin-games',
          meta: {
            title: 'Games',
            showInMenu: true,
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/games/Games.vue'),
        },

        {
          path: 'games/detail/:id',
          name: 'admin-game__detail',
          meta: {
            showInMenu: false,
            title: 'Game',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/games/GameDetail.vue'),
          children: [
            {
              path: 'seo',
              name: 'admin-game__seo',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                ],
              },
            },
          ],
        },

        {
          path: 'upsales',
          name: 'admin-upsales',
          meta: {
            showInMenu: true,
            title: 'Upsales',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/upsales/Upsales.vue'),
          redirect: { name: 'admin-upsales__data' },
          children: [
            {
              path: 'main',
              name: 'admin-upsales__data',
              component: () => import('Root/pages/admin/upsales/tabs/UpsalesData.vue'),
            },
            {
              path: 'managers',
              name: 'admin-upsales__managers',
              component: () => import('Root/pages/admin/orders/tabs/ManagerCabinet.vue'),
            },
            {
              path: 'settings',
              name: 'admin-upsales__settings',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SALES_HEAD.id,
                ],
              },
              component: () => import('Root/pages/admin/upsales/tabs/UpsalesSettings.vue'),
            },
            {
              path: 'history',
              name: 'admin-upsales__history',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SALES_HEAD.id,
                ],
              },
              component: () => import('Root/pages/admin/upsales/tabs/UpsalesHistory.vue'),
            },
            {
              path: 'macroses',
              name: 'admin-upsales__macroses',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                ],
              },
              component: () => import('Root/pages/admin/upsales/tabs/UpsalesMacroses.vue'),
            },
          ],
        },

        {
          path: 'upsales/macroses/create',
          name: 'admin-macros_create',
          meta: {
            title: 'Macros create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/upsales/MacrosDetail.vue'),
        },

        {
          path: 'upsales/macroses/:id',
          name: 'admin-macros_edit',
          meta: {
            title: 'Macros edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/upsales/MacrosDetail.vue'),
        },

        {
          path: 'chat',
          name: 'admin-chat-settings',
          meta: {
            title: 'Chat settings',
            showInMenu: true,
            roles: [
              UserModel.ROLES.ADMIN.id,
            ],
          },
          redirect: { name: 'admin-chat__forbidden-words' },
          component: () => import('Root/pages/admin/chat/ChatSettings.vue'),
          children: [
            {
              path: 'forbidden-words',
              name: 'admin-chat__forbidden-words',
              meta: {
                roles: [UserModel.ROLES.ADMIN.id],
              },
              component: () => import('Root/pages/admin/chat/tabs/ChatForbiddenWords.vue'),
            },
          ],
        },
        {
          path: 'orders/:id',
          name: 'admin-orders__order',
          meta: {
            title: 'Order main',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.PROJECT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/orderDetail/OrderDetail.vue'),
          redirect: { name: 'admin-orders__order-main' },
          children: [
            {
              path: 'main',
              name: 'admin-orders__order-main',
              component: () => import('Root/pages/admin/orderDetail/tabs/MainOrderDetail.vue'),
            },
            {
              path: 'history',
              name: 'admin-orders__order-history',
              component: () => import('Root/pages/admin/orderDetail/tabs/HistoryOrderDetail.vue'),
            },
            {
              path: 'metadata',
              name: 'admin-orders__order-metadata',
              component: () => import('Root/pages/admin/orderDetail/tabs/MetadataOrderDetail.vue'),
            },
            {
              path: 'child-orders',
              name: 'admin-orders__order-child-orders',
              component: () => import('Root/pages/admin/orderDetail/tabs/ChildOrdersOrderDetail.vue'),
            },
            {
              path: 'chat',
              name: 'admin-orders__order-chat',
              component: () => import('Root/pages/admin/orderDetail/tabs/ChatOrdersDetail.vue'),
            },
            {
              path: 'transactions',
              name: 'admin-orders__order-transactions',
              component: () => import('Root/pages/admin/orderDetail/tabs/TransactionsOrderDetail.vue'),
            },
          ],
        },

        {
          path: ':entity/:id/refund',
          name: 'admin-orders_refund',
          meta: {
            title: 'Refund create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/RefundCreate.vue'),
        },

        {
          path: 'order_custom_sale/create',
          name: 'admin-custom-order-create',
          meta: {
            title: 'Custom order create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: ['admin/getUsers', 'admin/getCategories'],
          },
          component: () => import('Root/pages/admin/components/OrderCustomSaleDetail.vue'),
        },

        {
          path: 'order_custom_sale/:id',
          name: 'admin-custom-orders_edit',
          redirect: { name: 'admin-orders__order-main' },
        },

        {
          path: 'products',
          name: 'admin-products',
          meta: {
            showInMenu: true,
            title: 'Products',
            icon: 'products.svg',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/Products.vue'),
        },

        {
          path: 'raids',
          name: 'admin-raids',
          meta: {
            showInMenu: true,
            title: 'Raids',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          redirect: { name: 'admin-raids_main' },
          component: () => import('Root/pages/admin/raids/Raids.vue'),

          children: [
            {
              path: 'main',
              name: 'admin-raids_main',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/raids/tabs/RaidsMain.vue'),
            },

            {
              path: 'schedules',
              name: 'admin-raids_schedules',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/raids/tabs/RaidsSchedules.vue'),
            },

            {
              path: 'teams',
              name: 'admin-raids_teams',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/raids/tabs/RaidsTeams.vue'),
            },
          ],
        },

        {
          path: 'raids/create',
          name: 'admin-raids_create',
          meta: {
            title: 'Raid create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsDetail.vue'),
        },

        {
          path: 'raids/:id',
          name: 'admin-raids_edit',
          meta: {
            title: 'Raid edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsDetail.vue'),

          children: [
            {
              path: 'raid-schedules',
              name: 'admin-raids_raid-schedules',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },

            {
              path: 'raid-events',
              name: 'admin-raids_events',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },

            {
              path: 'booked-raid-events',
              name: 'admin-raids_booked-events',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
          ],
        },

        {
          path: 'raids/schedules/create',
          name: 'admin-schedules_create',
          meta: {
            title: 'Schedule create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsSchedulesDetail.vue'),
        },

        {
          path: 'raids/schedules/:id',
          name: 'admin-schedules_edit',
          meta: {
            title: 'Schedule edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsSchedulesDetail.vue'),
        },

        {
          path: 'raids/teams/create',
          name: 'admin-raids-teams_create',
          meta: {
            title: 'Team create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsTeamsDetail.vue'),
        },

        {
          path: 'raids/teams/:id',
          name: 'admin-raids-teams_edit',
          meta: {
            title: 'Team edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/raids/RaidsTeamsDetail.vue'),
        },

        {
          path: 'currency',
          name: 'admin-currency',
          meta: {
            showInMenu: true,
            title: 'Marketplace',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/currency/Currency.vue'),
          redirect: { name: 'admin-currency__gold' },
          beforeEnter: checkCurrencyMarketPlaceAccess,
          children: [
            {
              path: 'gold',
              name: 'admin-currency__gold',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/currency/tabs/CurrencySettings.vue'),
            },
            {
              path: 'accounts',
              name: 'admin-currency__accounts',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/currency/tabs/AccountsSettings.vue'),
            },
            {
              path: 'offer-review',
              name: 'admin-currency__accounts-review',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/currency/tabs/OffersReview.vue'),
            },
            {
              path: 'offers',
              name: 'admin-currency__accounts-offers',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/currency/tabs/Offers.vue'),
            },
          ],
        },

        {
          path: 'currency/setting/:id',
          name: 'admin-currency__setting',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/currency/CurrencySettingDetail.vue'),
          beforeEnter: checkCurrencyMarketPlaceAccess,
          redirect: { name: 'admin-currency__setting-general' },
          children: [
            {
              path: '',
              name: 'admin-currency__setting-general',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: '',
              name: 'admin-currency__setting-fields',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: '',
              name: 'admin-currency__setting-offers',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: '',
              name: 'admin-currency__setting-presets',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
          ],
        },

        {
          path: 'products/:id',
          name: 'admin-product-more',
          meta: {
            title: 'Product',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/product/ProductDetail.vue'),
          redirect: { name: 'admin-product-more__general' },
          children: [
            {
              path: '',
              name: 'admin-product-more__general',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
                routeActions: ['admin/getAllTags'],
              },
            },
            {
              path: 'options',
              name: 'admin-product-more__options',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: 'seo',
              name: 'admin-product-more__seo',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: 'app',
              name: 'admin-product-more__app',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: 'raid',
              name: 'admin-product-more__raid',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
          ],
        },

        {
          path: 'product-history',
          name: 'admin-product-history',
          meta: {
            showInMenu: true,
            title: 'Products history',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
            routeActions: ['admin/getAllTags'],
          },
          component: () => import('Root/pages/admin/ProductHistory.vue'),
        },

        {
          path: 'hotsales',
          name: 'hotsales',
          meta: {
            showInMenu: true,
            title: 'Hotsales',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/hotsales/Hotsales.vue'),
          redirect: { name: 'hotsales__hotsale-offers' },
          children: [
            {
              path: 'hotsale-offers',
              name: 'hotsales__hotsale-offers',
              component: () => import('Root/pages/admin/hotsales/tabs/HotsaleOffers.vue'),
            },
            {
              path: 'popular-offers',
              name: 'hotsales__popular-offers',
              component: () => import('Root/pages/admin/hotsales/tabs/PopularOffers.vue'),
            },
            {
              path: 'hot-offers',
              name: 'hotsales__hot-offers',
              component: () => import('Root/pages/admin/hotsales/tabs/HotOffers.vue'),
            },
            {
              path: 'product-of-the-day',
              name: 'hotsales__product-of-the-day',
              component: () => import('Root/pages/admin/hotsales/tabs/ProductOfTheDay.vue'),
            },
            {
              path: 'landings-hot-offers',
              name: 'hotsales__landings-hot-offers',
              component: () => import('Root/pages/admin/hotsales/tabs/LandingsHotOffers.vue'),
            },
          ],
        },
        {
          path: 'tags',
          name: 'admin-tags',
          meta: {
            showInMenu: true,
            title: 'Tags',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/tags/Tags.vue'),
        },

        {
          path: 'tags/create',
          name: 'admin-tags_create',
          meta: {
            title: 'Tag create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: ['admin/getAllTags'],
          },
          component: () => import('Root/pages/admin/tags/TagDetail.vue'),
        },

        {
          path: 'tags/tree',
          name: 'admin-tags_tree',
          meta: {
            title: 'Tags tree',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: ['admin/getAllTags'],
          },
          component: () => import('Root/pages/admin/tags/TagsTree.vue'),
        },

        {
          path: 'tags/:id',
          name: 'admin-tags_edit',
          meta: {
            title: 'Tag edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: ['admin/getAllTags'],
          },
          component: () => import('Root/pages/admin/tags/TagDetail.vue'),
        },

        {
          path: 'users',
          name: 'admin-users',
          meta: {
            showInMenu: true,
            title: 'Users',
            icon: 'users.svg',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/users/Users.vue'),
          redirect: { name: 'admin-users__all' },
          children: [
            {
              path: 'all',
              name: 'admin-users__all',
              component: () => import('Root/pages/admin/users/tabs/AllUsers.vue'),
            },
            {
              path: 'maybe-scam',
              name: 'admin-users__maybe-scam',
              component: () => import('Root/pages/admin/users/tabs/MaybeScamUsers.vue'),
            },
            {
              path: 'cashback-accrual',
              name: 'admin-users__cashback-accrual',
              component: () => import('Root/pages/admin/users/tabs/CashbackAccrual.vue'),
            },
          ],
        },

        {
          path: 'users/create',
          name: 'admin-users_create',
          meta: {
            title: 'User create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
            routeActions: ['admin/getCategories'],
          },
          component: () => import('Root/pages/admin/components/UserDetail.vue'),
        },

        {
          path: 'users/:id',
          name: 'admin-users_edit',
          meta: {
            title: 'Customer main',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/userPage/UserPage.vue'),
          redirect: { name: 'admin-user-main' },
          children: [
            {
              path: 'main',
              name: 'admin-user-main',
              component: () => import('Root/pages/admin/userPage/tabs/UserMain.vue'),
            },
            {
              path: 'history',
              name: 'admin-user-history',
              component: () => import('Root/pages/admin/userPage/tabs/UserHistory.vue'),
            },
            {
              path: 'cashback-history',
              name: 'admin-user-cashback-history',
              component: () => import('Root/pages/admin/userPage/tabs/UserCashbackHistory.vue'),
            },
            {
              path: 'reviews',
              name: 'admin-user-reviews',
              component: () => import('Root/pages/admin/userPage/tabs/UserReviews.vue'),
            },
            {
              path: 'fails',
              name: 'admin-user-fails',
              component: () => import('Root/pages/admin/userPage/tabs/UserFails.vue'),
            },
            {
              path: 'metadata',
              name: 'admin-user-metadata',
              component: () => import('Root/pages/admin/userPage/tabs/UserMetadata.vue'),
            },
            {
              path: 'changes-history',
              name: 'admin-user-changes-history',
              component: () => import('Root/pages/admin/userPage/tabs/UserHistoryTable.vue'),
            },
            {
              path: 'scam-info',
              name: 'admin-user-scam-info',
              component: () => import('Root/pages/admin/userPage/tabs/ScamInfo.vue'),
            },
            {
              path: 'visits',
              name: 'admin-user-visits',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                ],
              },
              component: () => import('Root/pages/admin/userPage/tabs/UserVisits.vue'),
            },
            {
              path: 'ab-tests',
              name: 'admin-user-ab-tests',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                ],
              },
              component: () => import('Root/pages/admin/userPage/tabs/UserABTests.vue'),
            },
            {
              path: 'upsales',
              name: 'admin-user-upsales',
              component: () => import('Root/pages/admin/userPage/tabs/UserUpsales.vue'),
            },
          ],
        },

        {
          path: 'users-old/:id',
          name: 'admin-users_old-edit',
          meta: {
            title: 'User edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/UserDetailWrapper.vue'),
          redirect: { name: 'admin-user-index' },
          children: [
            {
              path: '',
              name: 'admin-user-index',
              meta: {
                title: 'User edit',
                routeActions: ['admin/getCategories'],
              },
              component: () => import('Root/pages/admin/components/UserDetail.vue'),
            },
            {
              meta: {
                title: 'Pro orders',
              },
              path: 'booster-orders',
              name: 'admin-user-booster_orders',
              component: () => import('Root/pages/admin/components/UserDetailBoosterOrders.vue'),
            },
            {
              meta: {
                title: 'Pro custom orders',
              },
              path: 'booster-orders-custom',
              name: 'admin-user-booster_custom_orders',
              component: () => import('Root/pages/admin/components/UserDetailBoosterCustomOrders.vue'),
            },
          ],
        },

        {
          path: 'executors',
          name: 'admin-executors',
          meta: {
            showInMenu: true,
            title: 'PRO-gamers',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/Executors.vue'),
        },

        {
          path: 'promocodes',
          name: 'admin-promocodes',
          meta: {
            showInMenu: true,
            title: 'Promocodes',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/Promocodes/PromocodesList.vue'),
        },

        {
          path: 'promocodes/create',
          name: 'admin-promocodes_create',
          meta: {
            title: 'Promocode create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/Promocodes/PromocodeDetail.vue'),
        },

        {
          path: 'promocodes/:id',
          name: 'admin-promocodes_edit',
          meta: {
            title: 'Promocode edit',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/Promocodes/PromocodeDetail.vue'),
        },

        {
          path: 'blocked_ip',
          name: 'admin-blocked-ip',
          meta: {
            showInMenu: true,
            title: 'Blocked IPs',
            roles: UserModel.ROLES.ADMIN.id,
          },
          component: () => import('Root/pages/admin/BlockedIps.vue'),
        },

        {
          path: 'blocked_ip/add',
          name: 'admin-blocked-ip-add',
          meta: {
            title: 'Blocked IP create',
            roles: UserModel.ROLES.ADMIN.id,
          },
          component: () => import('Root/pages/admin/BlockedIpAdd.vue'),
        },

        {
          path: 'reports',
          name: 'admin-reports',
          meta: {
            showInMenu: true,
            title: 'Reports',
            roles: UserModel.ROLES.ADMIN.id,
          },
          component: () => import('Root/pages/admin/Reports.vue'),
        },

        {
          path: 'payouts',
          name: 'admin-payouts',
          meta: {
            showInMenu: true,
            title: 'Payouts',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.FINANCE_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/Payouts.vue'),
        },

        {
          path: 'payouts-from-admin',
          name: 'admin-payouts-from-admin',
          meta: {
            showInMenu: true,
            title: 'Manual payouts',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/PayoutsFromAdmin.vue'),
        },
        {
          path: 'payouts-from-admin/create',
          name: 'admin-payouts_from_admin_create',
          meta: {
            title: 'Manual payout create',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/components/PayoutFromAdminDetail.vue'),
        },

        {
          path: 'bonuses-and-fines',
          name: 'admin-bonuses-and-fines',
          meta: {
            showInMenu: true,
            title: 'Bonuses and fines',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
              UserModel.ROLES.FINANCE_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/BonusesAndFines.vue'),
        },
        {
          path: 'finance-reports',
          name: 'finance-reports',
          redirect: { name: 'finance-reports__balance-reconciliations' },
          meta: {
            showInMenu: true,
            title: 'Finance reports',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.FINANCE_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/finance/FinanceReports.vue'),
          children: [
            {
              path: 'balance-reconciliations',
              name: 'finance-reports__balance-reconciliations',
              meta: {
                title: 'Balance reconciliation',
              },
              component: () => import('Root/pages/admin/finance/tabs/BalanceReconciliations.vue'),
            },
            {
              path: 'refills',
              name: 'finance-reports__refills',
              meta: {
                title: 'Payins',
              },
              component: () => import('Root/pages/admin/finance/tabs/Refills.vue'),
            },
            {
              path: 'payouts',
              name: 'finance-reports__payouts',
              meta: {
                title: 'Payouts',
              },
              component: () => import('Root/pages/admin/finance/tabs/Payouts.vue'),
            },
            {
              path: 'commissions',
              name: 'finance-reports__commissions',
              meta: {
                title: 'P&L',
              },
              component: () => import('Root/pages/admin/finance/tabs/Commissions.vue'),
            },
            {
              path: 'external-commissions',
              name: 'finance-reports__external-commissions',
              meta: {
                title: 'Payment system fees (external)',
              },
              component: () => import('Root/pages/admin/finance/tabs/ExternalCommissions.vue'),
            },
            {
              path: 'payout-table',
              name: 'finance-reports__payout-table',
              meta: {
                title: 'Payout table',
              },
              component: () => import('Root/pages/admin/finance/tabs/PayoutTable.vue'),
            },
          ],
        },
        // Пока не актуально
        // {
        //   path: 'marketing-reports',
        //   name: 'marketing-reports',
        //   redirect: { name: 'marketing-reports__orders' },
        //   meta: {
        //     showInMenu: true,
        //     title: 'Marketing reports',
        //     roles: [
        //       UserModel.ROLES.ADMIN.id,
        //     ],
        //   },
        //   component: () => import('Root/pages/admin/marketing/MarketingReports.vue'),
        //   children: [
        //     {
        //       path: 'orders',
        //       name: 'marketing-reports__orders',
        //       meta: {
        //         title: 'Orders',
        //       },
        //       component: () => import('Root/pages/admin/marketing/tabs/Orders.vue'),
        //     },
        //   ],
        // },
        {
          path: 'candidates',
          name: 'admin-candidates',
          meta: {
            showInMenu: true,
            title: 'Candidates',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/Candidates.vue'),
        },

        {
          path: 'blog',
          name: 'admin-blog',
          meta: {
            showInMenu: true,
            title: 'Blog',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/Blog.vue'),
          redirect: { name: 'admin-blog__main' },
          children: [
            {
              path: 'main',
              name: 'admin-blog__main',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/blog/tabs/BlogMain.vue'),
            },
            {
              path: 'categories',
              name: 'admin-blog__categories',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/blog/tabs/BlogCategories.vue'),
            },
            {
              path: 'authors',
              name: 'admin-blog__authors',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/blog/tabs/BlogAuthors.vue'),
            },
          ],
        },

        {
          path: 'categories/create',
          name: 'admin-blog-category__create',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/BlogCategoriesDetail.vue'),
        },
        {
          path: 'categories/:id',
          name: 'admin-blog-category',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/BlogCategoriesDetail.vue'),
        },

        {
          path: 'article/:slug',
          name: 'admin-article',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/BlogArticleDetail.vue'),
          redirect: { name: 'admin-article__general' },
          children: [
            {
              path: '',
              name: 'admin-article__general',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: 'editor',
              name: 'admin-article__editor',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
            },
            {
              path: 'popular',
              name: 'admin-article__popular',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/blog/tabs/BlogPopular.vue'),
            },
            {
              path: 'related',
              name: 'admin-article__related',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.CONTENT_MANAGER.id,
                ],
              },
              component: () => import('Root/pages/admin/blog/tabs/BlogRelatedArticles.vue'),
            },
          ],
        },

        {
          path: 'authors/:slug',
          name: 'admin-blog-author',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/BlogAuthorsDetail.vue'),
        },

        {
          path: 'authors/create',
          name: 'admin-blog-author__create',
          meta: {
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
            ],
          },
          component: () => import('Root/pages/admin/blog/BlogAuthorsDetail.vue'),
        },

        {
          path: 'ab-testing',
          name: 'admin-ab-testing',
          meta: {
            showInMenu: true,
            title: 'AB Testing',
            roles: [
              UserModel.ROLES.ADMIN.id,
            ],
          },
          component: () => import('Root/pages/admin/abTesting/Tests.vue'),
        },
        {
          path: 'ab-testing/create',
          name: 'admin-ab-testing_create',
          meta: {
            title: 'Create AB Test',
            roles: [
              UserModel.ROLES.ADMIN.id,
            ],
          },
          component: () => import('Root/pages/admin/abTesting/TestDetail.vue'),
        },
        {
          path: 'ab-testing/:id',
          name: 'admin-ab-testing_edit',
          meta: {
            title: 'AB Test',
            roles: [
              UserModel.ROLES.ADMIN.id,
            ],
          },
          component: () => import('Root/pages/admin/abTesting/TestDetail.vue'),
        },
        {
          path: 'reviews',
          name: 'admin-reviews',
          meta: {
            showInMenu: true,
            title: 'Reviews',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SUPPLY_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/Reviews.vue'),
        },
        {
          path: 'autoprice',
          name: 'admin-autoprice',
          meta: {
            showInMenu: true,
            title: 'Autoprice templates',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/autoprice/Autoprice.vue'),
          redirect: { name: 'admin-autoprice__main' },
          children: [
            {
              path: 'main',
              name: 'admin-autoprice__main',
              meta: {
                roles: [
                  UserModel.ROLES.ADMIN.id,
                  UserModel.ROLES.SUPPLY_MANAGER.id,
                  UserModel.ROLES.SALES_HEAD.id,
                ],
              },
              component: () => import('Root/pages/admin/autoprice/AutopriceMain.vue'),
            },
          ],
        },
        {
          path: 'autoprice/create/:id?',
          name: 'admin-autoprice__create',
          meta: {
            title: 'Create Autoprice template',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/autoprice/TemplateCreate.vue'),
          props: (route) => ({
            id: Number(route.params.id),
          }),
        },
        {
          path: 'autoprice/:id',
          name: 'admin-autoprice__edit',
          meta: {
            title: 'Edit Autoprice template',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/autoprice/TemplateCreate.vue'),
          props: (route) => ({
            id: Number(route.params.id),
          }),
        },
        {
          path: 'games/catalog/:id',
          name: 'admin-catalog-detail',
          meta: {
            showInMenu: false,
            title: 'Catalog Detail',
            roles: [
              UserModel.ROLES.ADMIN.id,
              UserModel.ROLES.CONTENT_MANAGER.id,
              UserModel.ROLES.SALES_MANAGER.id,
              UserModel.ROLES.SALES_HEAD.id,
            ],
          },
          component: () => import('Root/pages/admin/catalog/CatalogDetail.vue'),
        },
      ],
    },
  ];
}
